export default "__VITE_ASSET__CoBhN9sP__"